export enum BranchLaboratoryEnum {
  BRANCH_LABORATORY_REDIRECT_MODAL_TITLE = 'branch-laboratory-redirect-modal--title',
  BRANCH_LABORATORY_REDIRECT_MODAL_CLOSE_BUTTON = 'branch-laboratory-redirect-modal--close-button',
  BRANCH_LABORATORY_REDIRECT_MODAL_TEXT = 'branch-laboratory-redirect-modal--text',
  BRANCH_LABORATORY_REDIRECT_MODAL_LINK_REDIRECT = 'branch-laboratory-redirect-modal--link-redirect',
  BRANCH_LABORATORY_PROFILE_EXAMS_BUTTON = 'branch-laboratory-profile--exams-button',
}
